import type { CSSProperties, ReactNode } from 'react';

export interface TagProps {
    children?: ReactNode;
    /** Amostra de categoria, ex.: a cor do procedimento. */
    color?: string;
    onRemove?: () => void;
    style?: CSSProperties;
}

export function Tag({ children, onRemove, color, style }: TagProps) {
    return (
        <span
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 6, height: 24,
                padding: onRemove ? '0 5px 0 9px' : '0 9px',
                borderRadius: 'var(--radius-xs)', background: 'var(--surface)', border: '1px solid var(--border)',
                fontFamily: 'var(--font-ui)', fontSize: 12, fontWeight: 500, color: 'var(--neutral-700)', ...style,
            }}
        >
            {color && <span style={{ width: 7, height: 7, borderRadius: 2, background: color }} />}
            {children}
            {onRemove && (
                <button
                    type="button" onClick={onRemove} aria-label="Remover"
                    style={{ border: 0, background: 'transparent', cursor: 'pointer', color: 'var(--neutral-500)', fontSize: 13, lineHeight: 1, padding: '2px 3px', borderRadius: 4 }}
                >
                    ×
                </button>
            )}
        </span>
    );
}
